export default __webpack_public_path__ + "static/hat-aa52f2860ea74c8be95696d9f0223fbb.png";